var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('v-select',{staticClass:"admin-corporation-switch",attrs:{"items":_vm.selectableCorporations,"label":_vm.$t('corporation.singular'),"item-text":"name","item-value":"id","value":_vm.corporation,"dense":"","hide-details":"auto"},on:{"change":_vm.changeCorporation}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }